module.exports = __webpack_public_path__ + "static/media/new-order.7cab8455.mp3";